import http from "./http"
import { ImagePack } from "../models/imagePack"

class ImagePackService {
  private readonly baseUrl = "/image-pack"

  async list() {
    const { data } = await http.get<ImagePack[]>(this.baseUrl)
    return data
  }
}

export default new ImagePackService()
